import { TabType } from "@website/accommodation-ui/tour-card/tour-card-hotel/tour-card-hotel-furthermore/types";
import {
  USER_TRACKING_EVENTS,
  WEBENGAGE_EVENTS
} from "@website/tracking/tracking.types";

export const tabs: Array<TabType> = [
  {
    title: "امکانات هتل",
    btnName: "امکانات",
    btnNameCard: "امکانات هتل",
    key: "features",
    webengageEventName: WEBENGAGE_EVENTS.TOUR_ST_HOTEL_DETAILS_FACILITIES,
    userTrackingEventName: USER_TRACKING_EVENTS.TOUR_ST_HOTEL_DETAILS_FACILITIES
  },
  {
    title: "امتیاز هتل از دید کاربران اسنپ‌تریپ",
    btnName: "نظرات",
    btnNameCard: "امتیاز و نظرات",
    key: "review",
    webengageEventName: WEBENGAGE_EVENTS.TOUR_ST_HOTEL_DETAILS_RATE_REVIEW,
    userTrackingEventName:
      USER_TRACKING_EVENTS.TOUR_ST_HOTEL_DETAILS_RATE_REVIEW
  },
  {
    title: "موقعیت مکانی هتل",
    btnName: "موقعیت مکانی",
    btnNameCard: "موقعیت مکانی",
    key: "location",
    webengageEventName: WEBENGAGE_EVENTS.TOUR_ST_HOTEL_DETAILS_LOCATION,
    userTrackingEventName: USER_TRACKING_EVENTS.TOUR_ST_HOTEL_DETAILS_LOCATION
  },
  {
    title: "گالری تصاویر",
    btnName: "تصاویر",
    btnNameCard: "تصاویر هتل",
    key: "gallery"
  }
];

export const hotelButtons = tabs.filter((tab) => tab.key !== "features");
